import React from 'react';
import style from './style.module.css'

export default function Loading(props) {
  return (
    <div className={style.loadingContainer} {...props}>
      <div className={style.loading}>
        <div className={style.shape1}></div>
        <div className={style.shape1}></div>
        {!props.small && (
          <>
            <div className={style.shape1}></div>
            <div className={style.shape1}></div>
          </>
        )}
        <div className={style.shape2}></div>
      </div>
    </div>
  )
}